import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/collection/collection-container.tsx");
